/*
 * @Author: 沉梦 chenmxgg@163.com <blog.achaci.cn>
 * @Date: 2022-10-19 19:31:44
 * @LastEditors: 沉梦 chenmxgg@163.com <blog.achaci.cn>
 * @LastEditTime: 2022-10-21 21:02:16
 * @FilePath: \v1.0.0.2\src\store\modules\user.js
 * @Description: 
 * 
 * Copyright (c) 2022 by 成都沉梦科技, All Rights Reserved. 
 */

import tool from "@/utils/tool";
import authConfig from "@/config/auth";

// 辅助函数：处理请求路径
function socketHandlePath(path) {
    let arr = path.split('//');
    if (arr.length >= 2) {
        path = arr[1];
        let parts = path.split('/', 2);
        if (parts.length > 1) {
            path = path.substring(parts[0].length + 1);
        }
    }

    if (path.startsWith('/')) {
        path = path.substr(1);
    }

    return path;
}

// WebSocket 相关的 Vuex 模块
const socketModule = {
    namespaced: true,
    state: {
        // 更改为对象，以存储不同URL对应的WebSocket实例
        gateway_servers: {},
        gateway_server: null,
        baseType: null,
        ws: null,
        connectOk: false,
        isFirst: true,
        connectErrorIndex: 0,
        myInterval: null,
        waitSends: [],
        callbacks: {},
        sendBeforeFun: null, // 用于保存 sendBefore 函数
        callBeforeFun: null, // 用于保存 callBefore 函数
        sendBeforeFunAsync: true,
        callBeforeFunAsync: true,
        timeout: 30 * 1000,
    },
    mutations: {
        Init(state, {gateway_server, baseType}) {
            if (!gateway_server || gateway_server == 'null') {
                return;
            }
            state.gateway_server = gateway_server;
            state.baseType = baseType;
            state.sendBeforeFun = (params) => {
                console.log('params', params);
                const {data, url} = params;
                let path = socketHandlePath(url);
                data.user_token = tool.data.get('token');
                data.token = tool.data.get('token');
                data.host = 'webInfo' in window ? ('host' in window.webInfo ? window.webInfo.host : 'localhost:8080') : 'localhost:8080';
                return [data, {type: 'index', path}];
            };
            state.callBeforeFun = (response) => {
                if (response.code != 200) {
                    if (response.code == authConfig.nologin.code) {
                        // Toast.fail(authConfig.nologin.message);
                        authConfig.nologin.action()
                        return Promise.reject(response)
                    } else if (response.code == authConfig.noauth.code) {
                        // Toast.fail(authConfig.noauth.message);
                        authConfig.noauth.action()
                        return Promise.reject(response)
                    } else {
                        return Promise.resolve(Object.assign(response, {
                            'data': typeof response.data == 'undefined' ? [] : response.data
                        }))
                    }
                } else {
                    return response;
                }
            }
        },
        setConnectStatus(state, status) {
            state.connectOk = status;
            state.isFirst = !status;
        },
        resetConnectErrorIndex(state) {
            state.connectErrorIndex = 0;
        },
        incrementConnectErrorIndex(state) {
            state.connectErrorIndex += 1;
        },
        clearMyInterval(state) {
            clearInterval(state.myInterval);
            state.myInterval = null;
        },
        setTimeout(state, timeout) {
            state.timeout = timeout;
        },
        addWaitSend(state, payload) {
            state.waitSends.push(payload);
        },
        clearWaitSends(state) {
            state.waitSends = [];
        },
        createCallback(state, {id, call}) {
            const setTimeoutId = setTimeout(() => {
                if (state.callbacks[id]) {
                    state.callbacks[id].call(this.timeoutRes);
                    delete state.callbacks[id];
                }
            }, state.timeout);

            state.callbacks[id] = {
                call: call,
                setTimeoutId: setTimeoutId
            };
            console.log('state.callbacks', state.callbacks);
        },
        setWs(state, {ws, url}) {
            if (url in state.gateway_servers) {
                state.gateway_servers[url].ws = ws
            } else {
                state.gateway_servers[url] = {
                    ws: ws,
                    // 如果需要，可以在这里为新的连接初始化其他状态属性
                    connectOk: false,
                    isFirst: true,
                    connectErrorIndex: 0,
                    myInterval: null,
                    waitSends: [],
                    callbacks: {}
                }
            }
            // Vue.set(state.gateway_servers[url], 'ws', ws);
        },
        setHeartbeatInterval(state, Interval) {
            state.myInterval == Interval
        }
    },
    actions: {
        // 初始化 WebSocket 连接
        init({commit, dispatch}, {url, baseType}) {
            if (!url.includes('ws')) {
                url = url.includes('https') ? 'wss://' + url.replace('https://', '') : 'ws://' + url.replace('http://', '');
            }
            commit('Init', {url, baseType});
            dispatch('connect');
        },
        // 创建 WebSocket 连接
        connect({state, commit, dispatch}) {
            if (!state.gateway_server) return;



            const ws = new WebSocket(state.gateway_server);

            ws.onmessage = (e) => dispatch('handleMessage', e);
            ws.onopen = () => {
                console.info('iothome提示: 异步会话服务链接成功');
                commit('setConnectStatus', true);
                commit('resetConnectErrorIndex');

                if (!state.myInterval) {
                    dispatch('startHeartbeat');
                }

                state.waitSends.forEach((item) => dispatch('send', ...item));
                commit('clearWaitSends');
            };

            ws.onclose = () => {
                commit('setConnectStatus', false);
                commit('clearMyInterval');

                setTimeout(() => {
                    if (state.connectErrorIndex < 3) {
                        dispatch('connect', state.gateway_server);
                    } else {
                        // Handle long connection timeout
                    }
                }, 10000);
            };

            ws.onerror = (e) => {
                commit('setConnectStatus', false);
                console.error("出现错误", e);
            };
            commit('setWs', ws);
        },

        // 开始心跳包发送
        startHeartbeat({state, dispatch, commit}) {
            dispatch('keepOnLine');
            const Interval = setInterval(() => dispatch('keepOnLine'), 80 * 1000);
            commit('setHeartbeatInterval', Interval);
        },
        // 发送心跳包
        keepOnLine({state, dispatch}) {
            if (state.connectOk) {
                state.ws.send(JSON.stringify({type: 'ping'}));
            } else if (state.isFirst && state.connectErrorIndex === 0) {
                console.log('自动断线重连');
                dispatch('connect');
            }
        },
        // 发送检测信息
        checkApi({state}) {
            state.ws.send(JSON.stringify({type: state.baseType, wsaction: 'check'}));
        },

        // 处理收到的消息
        async handleMessage({state, commit, dispatch}, e) {
            try {
                const data = JSON.parse(e.data);
                if (data) {
                    switch (data.type) {
                        case 'ping':
                            break;
                        case 'check':
                            console.log('Socket check received');
                            break;
                        case 'call':
                            if (data.id && state.callbacks[data.id]) {
                                let processedData = state.callBeforeFunAsync
                                    ? await state.callBeforeFun(data)
                                    : state.callBeforeFun(data);

                                state.callbacks[data.id].call(processedData);
                                clearTimeout(state.callbacks[data.id].setTimeoutId);
                                delete state.callbacks[data.id];
                            }
                            break;
                        default:
                            console.warn('Unknown message type:', data.type);
                    }
                }
                else {
                    console.error("WS错误消息: WS回调解析失败", data);
                }
            } catch (error) {
                console.error("WS错误消息:", e.data, error);
            }
        },
        // 发送信息
        async send({state, commit, dispatch}, payload) {
            if (state.connectOk) {

                let {
                    method,
                    url,
                    data,
                    call
                } = payload
                let [resData, resParams] = state.sendBeforeFunAsync
                    ? await state.sendBeforeFun({
                        method,
                        url,
                        data,
                        call
                    })
                    : state.sendBeforeFun({
                        method,
                        url,
                        data,
                        call
                    });
                const post = resParams
                    ? {...{id: tool.crypto.MD5(JSON.stringify([...payload]) + Math.random()), data: resData}, ...resParams}
                    : {id: tool.crypto.MD5(JSON.stringify([...payload]) + Math.random()), data: resData};

                dispatch('createCallback', {id: post.id, call: call});
                state.ws.send(JSON.stringify(post));
            } else {
                commit('addWaitSend', payload);
                if (!state.isFirst && state.connectErrorIndex < 3) {
                    console.log('自动断线重连');
                    dispatch('connect', state.gateway_server);
                }
            }
        },
        // 创建回调
        createCallback({state, commit}, {id, call}) {
            if (Object.prototype.toString.call(call) === '[object Function]') {
                commit('createCallback', {id, call});
            }
        },
    },
};

export default socketModule;


// WEBPACK FOOTER //
// ./src/store/modules/ws.js